export const editMutations = <const>{
	TYP_TABULKOVA_POZICE_SELECT_MAPPER: 'TYP_TABULKOVA_POZICE_SELECT_MAPPER',
};
